import React from 'react';
import { useTranslation } from 'react-i18next';
import '../../CSS/menuSection1.css';

const MenuSection1 = ({
  title = "ACTUALITÉS",
  subtitle1 = "TOUS LES ARTICLES", 
  subtitle2 = "ACTUALITÉS",
  subtitle3 = "COMPTES RENDUS",
  subtitle4 = "COMMUNIQUÉS",
  categories = null,
  backgroundColor = "#f8f9fa",
  textColor = "#0a3764",
  accentColor = "#7d3f98",
  className = "",
  onCategoryClick,
  selectedCategory = "TOUS LES ARTICLES",
  loading = false
}) => {
  
  const { t } = useTranslation();

  // Fonction pour déterminer la classe d'un sous-titre
  const getSubtitleClass = (category) => {
    return `menu-subtitle ${category === selectedCategory ? 'active' : ''}`;
  };

  // Fonction pour vérifier si un sous-titre doit être affiché
  const shouldDisplaySubtitle = (subtitle) => {
    return subtitle && subtitle.trim() !== "" && subtitle !== "DISABLED";
  };

  // Logique pour déterminer quelles catégories afficher
  const getDisplayCategories = () => {
    // Si on a un tableau de catégories et qu'il n'est pas vide, on l'utilise
    if (categories && Array.isArray(categories) && categories.length > 0) {
      console.log("📋 MenuSection1 - Catégories reçues:", categories);
      return categories;
    }
    
    // Sinon, on utilise les sous-titres individuels (compatibilité)
    const subtitles = [];
    if (shouldDisplaySubtitle(subtitle1)) subtitles.push(subtitle1);
    if (shouldDisplaySubtitle(subtitle2)) subtitles.push(subtitle2);
    if (shouldDisplaySubtitle(subtitle3)) subtitles.push(subtitle3);
    if (shouldDisplaySubtitle(subtitle4)) subtitles.push(subtitle4);
    
    console.log("📋 MenuSection1 - Catégories par défaut:", subtitles);
    return subtitles;
  };

  const displayCategories = getDisplayCategories();

  // Si chargement, afficher un indicateur
  if (loading) {
    return (
      <section
        className={`menu-section1 ${className}`}
        style={{
          backgroundColor,
          color: textColor,
          justifyContent: "space-between"
        }}
      >
        <div>
          <h2 className="menu-section1-title" style={{ color: textColor }}>
            {title === "ACTUALITÉS" ? t('articles.title') : title}
          </h2>
          <div className="menu-section1-subtitles-container">
            <span className="menu-subtitle" style={{ color: textColor }}>
              Chargement...
            </span>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section
      className={`menu-section1 ${className}`}
      style={{
        backgroundColor,
        color: textColor,
        justifyContent: "space-between"
      }}
    >
      <div>
        <h2
          className="menu-section1-title"
          style={{ color: textColor }}
        >
          {title === "ACTUALITÉS" ? t('articles.title') : title}
        </h2>

        {/* Conteneur pour les sous-titres en bas */}
        <div className="menu-section1-subtitles-container">
          {displayCategories.length > 0 ? (
            displayCategories.map((category, index) => (
              <span
                key={index}
                className={getSubtitleClass(category)}
                style={{ color: textColor, cursor: "pointer" }}
                onClick={() => onCategoryClick && onCategoryClick(category)}
              >
                {category}
              </span>
            ))
          ) : (
            <span className="menu-subtitle" style={{ color: textColor }}>
              Aucune catégorie disponible
            </span>
          )}
        </div>
      </div>
    </section>
  );
};

export default MenuSection1;